import { Box, Text } from '@chakra-ui/react';
import { CodeBlock } from '../../../components';
import { BlueCheckApplication } from '../../../utils/types';

export const OAuthNewCodeRender = ({
  language,
  application,
  editMode,
}: {
  language: string;
  application: BlueCheckApplication | null;
  editMode: boolean;
}) => {
  const recentApp = application ? application : null;
  return (
    <Box w="100%" h="100%">
      <Text
        mt="10px"
        mb="2px"
        fontFamily="inter"
        className="small-font"
        fontWeight="bold"
        color="black.600"
      >
        Install the latest version of the SDK
      </Text>
      <CodeBlock
        code={language === 'react' ? INSTALL_COMMANDS.react : INSTALL_COMMANDS.js}
        language="shell"
        canCopy={true}
        className="x-small-font"
        framework=""
      />
      <Box h="fit-content" mt="10px">
        <Text
          mt="10px"
          fontFamily="inter"
          className="small-font"
          fontWeight="bold"
          mb="2px"
          color="black.600"
        >
          Integrate with your project:
        </Text>
        <CodeBlock
          className="x-small-font"
          code={
            language === 'react'
              ? getCodeSnippetForProduction(recentApp, editMode).reactClient
              : getCodeSnippetForProduction(recentApp, editMode).jsClient
          }
          language="javascript"
          canCopy={true}
          framework=""
        />
      </Box>
    </Box>
  );
};

export const INSTALL_COMMANDS = {
  react: 'npm i @bluecheck/react-library',
  js: '<script src="https://unpkg.com/reclaim-identity-js@latest"></script>',
};

export const getCodeSnippetForProduction = (
  app: BlueCheckApplication | null,
  editMode: boolean
) => {
  const reactClient = `
import { useState } from 'react';
import { EmploymentVerification, Proof } from '@bluecheck/react-library';

function App() {
  const [showVerification, setShowVerification] = useState(true);
  const appId = '${app ? app.id : 'YOUT_APPLICATION_ID'}';

  const handleProofVerified = (proof: Proof) => {
    console.log(proof);
    setShowVerification(false);
  };

  const handleClose = () => {
    setShowVerification(false);
  };

  const styles = {
    borderHoverColor: '#AB552F',
    backgroundColor: '#1E1E1E',
    borderColor: '#949494',
    textColor: 'white',
    fontType: "Hahmlet",
  }

  return (
    <>
      {showVerification && (
        <EmploymentVerification
          appId={appId}
          onProofVerified={handleProofVerified}
          onClose={handleClose}
          styles={styles}
        />)}
    </>
  );
}

export default App;
`;
  const jsClient = `
    const clientId = '${app ? app.id : 'YOUT_APPLICATION_ID'}';
    const clientSecret = '${app && !editMode ? app.clientSecret : 'YOUT_APPLICATION_SECRET'}';
    const redirectUri = '${app ? app.callbackUri : 'your-redirect-uri'}';
    const reclaimAuth = getReclaimAuth(clientId, clientSecret,redirectUri);
    reclaimAuth.signIn()
    .then(user => {
        console.log('Signed in:', user);
    })
    .catch(error => {
        if (error.message.includes('popup')) {
        console.error('Popup was blocked');
        } else {
        console.error('Authentication error:', error);
        }
    });

    // Sign Out
    reclaimAuth.signOut()
    .then(() => {
        console.log('Signed out successfully');
    })
    .catch(error => {
        console.error('Sign out error:', error);
    });

    // Get Current User
    const user = reclaimAuth.getCurrentUser();

    // Listen for Auth State Changes
    const unsubscribe = reclaimAuth.onAuthStateChanged(user => {
    if (user) {
        console.log('User state changed:', user);
    } else {
        console.log('User signed out');
    }
    });

    // Clean up listener when done
    unsubscribe();
`;

  return {
    reactClient,
    jsClient,
  };
};
